<template>
  <div class="home">
    <div class="columns is-multiline is-mobile">
      <div class="column is-4-tablet is-6-mobile is-3-desktop"
           v-if="enabledItems[item.name]"
           v-for="item in cardLinks"
           :key="item.name">
        <home-cards-item
          v-if="($alfalab.allowOnlyLapi($auth.user(), item))"
          prefix="specialties"
          :data="item"
        ></home-cards-item>
      </div>
    </div>
  </div>
</template>

<script>
import HomeCardsItem from "../../components/dashboard/HomeCardsItem";

export default {
  name: "Index",
  components: { HomeCardsItem },
  data(){
    return {
      enabledItems: {}
    }
  },
  computed: {
    cardLinks() {
      return this.$store.state.specialties.links || [];
    }
  },
  mounted() {
    this.getEnabledItems();
  },
  methods: {
    getEnabledItems(){
      this.$loader.show();
      this.$http.get('medical-specialty/enabled').then(({data}) => {
        this.enabledItems = data.data;
      }).finally(() => {
        this.$loader.hide();
      })
    }
  }
};
</script>

<style scoped>

</style>
